
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M3 11.245a6.67 6.67 0 0 0 2.886 3.413 6.26 6.26 0 0 0 4.31.73 6.43 6.43 0 0 0 3.775-2.283 6.92 6.92 0 0 0 1.528-4.26 6.93 6.93 0 0 0-1.413-4.304 6.45 6.45 0 0 0-3.712-2.392 6.25 6.25 0 0 0-4.328.604A6.65 6.65 0 0 0 3.07 6.08M7 6.5H2.5V2"}})])
          )
        }
      }
    